<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="uploadProgressDialog" persistent max-width="450px">
      <v-card class="pa-5">

        <div class="text-center">
          <h3>Uploading Files</h3>

          <p class="mt-3 mb-2">
            {{ uploadedFilesCount }} of {{ totalUploadFiles }} files uploaded
          </p>

          <v-progress-linear :value="uploadProgress" height="12" rounded striped></v-progress-linear>

          <div class="mt-2">
            {{ uploadProgress }}%
          </div>

          <p class="mt-3 mb-0 grey--text">
            Please do not close this window while files are uploading.
          </p>
        </div>

      </v-card>
    </v-dialog>
    <v-card class="box">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong>Album</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
              label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="stream" :items="stream_list" item-text="name" label="Stream"
              @change="get_divisions_stream(stream, 'stream')" outlined persistent-hint hint="Please Select Stream" />
          </v-col>
          <v-col sm="1">
            <br />
            <center><strong>OR</strong></center>
          </v-col>
          <!-- <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="standard" :items="standard_list_all" item-text="standard"
              item-value="id" label="Standard" multiple @change="get_divisions_stream(standard, 'standard')" outlined
              persistent-hint hint="Please Select Standard"></v-autocomplete>
          </v-col>
          <v-col sm="2" v-if="division_list != ''">
            <v-icon color="error">*</v-icon>
            <v-combobox dense required v-model="division" :items="division_list" item-text="divname" label="Division"
              outlined multiple />
          </v-col> -->
          <v-col cols="12" sm="2" md="2">
            <v-icon color="error">*</v-icon>
            <v-select dense required v-model="standard" :items="standard_list_all" item-text="standard" item-value="id"
              outlined multiple @change="get_divisions_stream(standard, 'standard')" persistent-hint
              hint="Please Select Standard">
              <template #label>
                Standard
              </template>
              <template v-slot:prepend-item>
                <v-list-item @mousedown.prevent>
                  <v-list-item-action>
                    <v-checkbox v-model="selected_all_standard" @change="toggle_standard()">
                      <template #label><span class="ml-8">Select All</span>
                      </template>
                    </v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete dense required v-model="division" :items="division_list" item-text="divname" item-value="id"
              outlined multiple>
              <template #label>
                Division
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.divname }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ division.length - 1 }} others)
                </span>
              </template>
              <template v-slot:prepend-item>
                <v-list-item @mousedown.prevent>
                  <v-list-item-action>
                    <v-checkbox v-model="selected_all_division" @change="toggle_division()">
                      <template #label><span class="ml-8">Select All</span>
                      </template>
                    </v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row> </v-row>
        <br>
        <span v-if="division != ''">
          <v-row dense justify="center">
            <v-col cols="6">
              <v-text-field label="Title" v-model="title" placeholder="Enter Title...." :rules="textRule" required
                prepend-icon="mdi-asterisk">
                <template v-slot:prepend>
                  <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field label="Link(If Any)" v-model="link" placeholder="URL"
                @change="validateWebinarURL(link)"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea label="Description" v-model="description" placeholder="Enter Description...."
                hint="Enter description of notice or home work"></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-file-input v-model="attachments" placeholder="Upload attachment if any" label="Attachment" multiple
                prepend-icon="mdi-paperclip">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </span>
        <v-btn @click="putCalendar" :loading="send_btn_load" v-if="division && title" color="info">Send</v-btn>
      </v-card-text>
    </v-card>
    <br />
    <v-row justify="center">
      <v-col cols="12" sm="2">
        <v-text-field outlined dense type="date" v-model="fromdate" label="From Date" hint="From Date"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field outlined dense type="date" v-model="todate" label="To Date" hint="To Date"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Albums</v-btn>
      </v-col>
    </v-row>
    <br>
    <v-row dense justify="center" v-if="communication_list != ''">
      <v-radio-group inline v-model="view" row>
        <v-radio label="Single" value="Single"></v-radio>
        <v-radio label="Cummalative" value="Cummalative"></v-radio>
      </v-radio-group>
    </v-row>

    <template v-if="view == 'Single'">
      <div>
        <v-data-table :items="communication_list" :headers="headers" class="elevation-1" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
              <v-toolbar-title><b>List of Albums</b></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="3" md="3">
                <v-text-field v-model="search" append-icon="search" label="Search" rounded background-color="white"
                  color="white" hide-details></v-text-field>
              </v-col>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-btn color="secondary" icon dark v-on="on" @click="editDialog(item)" title="Edit Event">
                <v-icon>mdi-file-document-edit</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-btn color="warning" icon dark v-on="on" @click="deleteCalendarEvent(item)" title="Delete Event"
                :loading="delete_attach_load">
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.url`]="{ item }">
            <a :href="item.url" target="_blank" v-if="item.url != '--'">
              <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
            </a>
            <span v-else style="opacity: 0.5;">{{ item.url }}</span>
          </template>
          <template v-slot:[`item.read_by_parent`]="{ item }">
            <div>
              <v-icon medium class="mr-2" @click="getStatus(item.id)"> mdi-eye-outline</v-icon>
            </div>
          </template>
        </v-data-table>
      </div>
    </template>
    <template v-if="view == 'Cummalative'">
      <v-row dense>
        <v-col cols="12" sm="12" md="12" v-for="(value, key) in cum_list" :key="key">
          <v-card class="box box1" fill-height>
            <v-btn style="float: right;" color="secondary" icon dark @click="handleCumulativeAction(key, 'edit')"
              title="Resend Album">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            <v-btn class="link" :loading="delete_loader" style="float:right" @click="deleteCommnByMsgId(key)"
              color="red"> <v-icon>mdi-trash-can</v-icon></v-btn>
            <span v-for="(std, ind) in value" :key="ind">
              <h3 v-if="ind == 0">Title : {{ value[0] }}</h3>
              <div v-else-if="ind == 1">
                <b> Description : </b>{{ value[1] }} <br />
                <!-- <span> {{ std }} </span><br /> -->
              </div>
              <v-btn color="info" small style="margin: 2px;" v-else>
                {{ std }}
              </v-btn>
            </span>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-dialog v-model="status_dialog" max-width="1200px">
      <v-card>
        <v-card-text>
          <v-data-table :headers="status_headers" :items="comm_read_ststus" :search="search">
            <template v-slot:top>
              <v-toolbar flat color="white" align="center" justify="center">
                <v-toolbar-title>List of Receipients</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <strong>Total Receipients- </strong>{{ total_receipients }}
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="search" label="Search" single-line
                  hide-details></v-text-field>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-center"><v-btn class="dialog-btn"
            @click="status_dialog = false">Close</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="edit_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.date"
                  label="Sent Date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.from" label="From"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem.to" label="To"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem.title" label="Title"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label="Description" v-model="editedItem.description" dense
                  placeholder="Colleges reopens on...." hint="editable"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem.url" label="Link"></v-text-field>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-file-input v-model="edit_attachments" placeholder="Upload attachment if any" label="Attachment"
                multiple prepend-icon="mdi-paperclip">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
            <template v-if="editedItem.attachment_list.length > 0">
              <h3>Attachments</h3>
              <ol>
                <li v-for="attach in editedItem.attachment_list" :key="attach.attach_id">
                  <a :href="awspath + attach.link">{{ attach.attach_name }}</a>
                  <v-btn text title="Delete attachment" :loading="delete_acttach_load"
                    @click="deleteAttachment(attach)">
                    <v-icon color="red">mdi-window-close</v-icon>
                  </v-btn>
                </li>
              </ol>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="edit_dialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="edit_save_attachment_load" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Cumulative Edit -->
    <v-dialog v-model="edit_cumulative_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem_for_cumulative_edit.date"
                  label="Sent Date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem_for_cumulative_edit.from"
                  label="From"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field dense hint="cannot edit" disabled v-model="editedItem_for_cumulative_edit.to"
                  label="To"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem_for_cumulative_edit.title"
                  label="Title"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem_for_cumulative_edit.url"
                  label="Link"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label="Description" v-model="editedItem_for_cumulative_edit.description" dense
                  placeholder="Colleges reopens on...." hint="editable"></v-textarea>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-file-input v-model="edit_attachments" placeholder="Upload attachment if any" label="Attachment"
                multiple prepend-icon="mdi-paperclip">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </v-col>
            <template v-if="editedItem_for_cumulative_edit.attachment_list.length > 0">
              <h3>Attachments</h3>
              <ol>
                <li v-for="attach in editedItem_for_cumulative_edit.attachment_list" :key="attach.attach_id">
                  <a :href="basepath + attach.link" target="_blank">{{ attach.attach_name }}</a>
                  <v-btn text title="Delete attachment" :loading="delete_acttach_load"
                    @click="deleteAttachment(attach)">
                    <v-icon color="red">mdi-window-close</v-icon>
                  </v-btn>
                </li>
              </ol>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="edit_cumulative_dialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" :loading="edit_cumulative_loader" text
            @click="handleCumulativeAction(editedItem_for_cumulative_edit.key, 'save')">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    file_upload_config: { allowed_type: "", max_size: 1000 },
    rules: [
      (value) =>
        !value || value.size < 2000000 || "Logo size should be less than 2 MB!",
    ],
    textRule: [(v) => !!v || "Field is required"],
    link: "",
    attachments: [],
    ay_list: [],
    description: "",
    academicyear: "",
    stream: "",
    stream_list: [],
    event_type_list: [],
    division_list: [],
    division: [],
    standard: [],
    event_type: "",
    datetime: null,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    send_btn_load: false,
    color: "",
    communication_list: "",
    awspath: null,
    selected_all_standard: false,
    selected_all_division: false,
    headers: [
      { text: "Academicyear", value: "academicyear", sortable: true },
      { text: "Sent Date", value: "date", sortable: true },
      { text: "From", value: "from", sortable: true },
      { text: "To", value: "to", sortable: true },
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
      { text: "Link", value: "url", sortable: true },
      { text: "View Status", value: "read_by_parent", sortable: true },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    status_headers: [
      { text: "Sr No", value: "srno", sortable: true },
      { text: "Read By", value: "learner", sortable: true },
      { text: "Read Date", value: "read_date", sortable: true },
    ],
    title: null,
    edit_dialog: false,
    delete_acttach_load: false,
    edit_save_attachment_load: false,
    edit_attachments: [],
    comm_read_ststus: [],
    status_dialog: false,
    total_receipients: "",
    communicationMap: null,
    editedItem: {
      date: null,
      attachment_list: [],
      description: "",
      from: null,
      id: null,
      to: null,
      title: null,
    },
    editedItem_for_cumulative_edit: {
      title: '',
      url: '',
      description: '',
      attachment_list: [],
      date: '',
      from: '',
      to: '',
      key: ''
    },
    edit_cumulative_dialog: false,
    edit_cumulative_loader: false,
    cum_list: [],
    basepath: null,
    fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
    todate: new Date().toISOString().slice(0, 10),
    view: null,
    delete_loader: false,
    standard_list_all: [],
    uploadBatchSize: 10,
    communicationId: null,
    uploadProgressDialog: false,
    uploadedFilesCount: 0,
    totalUploadFiles: 0,
    uploadProgress: 0,
    uploadCompleted: false,
  }),

  methods: {
    toggle_standard() {
      this.$nextTick().then(() => {
        if (this.selected_all_standard) {
          this.standard = [];
          for (var x in this.standard_list_all) {
            this.standard.push(this.standard_list_all[x].id);
          }
          this.get_divisions_stream(this.standard, 'standard')
        } else {
          this.standard = [];
        }
      });
    },
    toggle_division() {
      this.$nextTick().then(() => {
        if (this.selected_all_division) {
          this.division = [];
          for (var x in this.division_list) {
            this.division.push(this.division_list[x].id);
          }
        } else {
          this.division = [];
        }
      });
    },
    validateWebinarURL(link) {
      var myURL = link;
      var mytrimurl = myURL.trim();
      var pattern = new RegExp(
        "^((ft|htt)ps?:\\/\\/)?" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(\\:\\d+)?" +
        "(\\/[-a-z\\d%@_.~+&:]*)*" +
        "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" +
        "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      if (this.hasWhiteSpace(myURL)) {
        this.isvalid = true;
        return;
      } else if (pattern.test(mytrimurl)) {
        this.isvalid = true;
        return;
      } else {
        this.isvalid = false;
        alert("Please Enter Valid URL...!");
        return;
      }
    },
    fetchNotices() {
      this.init_loader = true;
      const formData = {
        comm_type: "Album",
        for: "all",
        fromdate: this.fromdate,
        todate: this.todate,
        ay: this.academicyear.id
      };
      axios
        .post("/Communication/getNoticesBetweenDates", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.d_ay = res.data.d_ay;
            this.from_date = res.data.from_date;
            this.to_date = res.data.to_date;
            this.communication_list = res.data.communication_list;
            this.cum_list = res.data.cum_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.init_loader = false;
        });
    },
    deleteAttachment(attach) {
      const formData = {
        attach_id: attach.attach_id,
      };
      this.delete_acttach_load = true;
      axios
        .post("/communicationType/deleteAttachment", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            const index = this.editedItem.attachment_list.indexOf(attach);
            this.editedItem.attachment_list.splice(index, 1);
            this.delete_acttach_load = false;
            this.showSnackbar("green", "Attachment Deleted Successfully...");
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.delete_acttach_load = false;
        });
    },
    async deleteCommnByMsgId(key) {
      this.delete_loader = true;
      const formdata = {
        key: key
      };
      try {
        const res = await axios.post("/communication/deleteCommnByMsgId", formdata);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", res.data.snackbar);
          this.get_ay_std();
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        this.showSnackbar("red", "Something went wrong!!!");
        console.log("err", err);
      } finally {
        this.delete_loader = false;
      }
    },
    clearData() {
      this.division = [];
      this.stream = "";
      this.title = "";
      this.link = "";
      this.description = "";
      this.attachments = [];
    },
    getStatus(id) {
      const formData = {
        comm_id: id,
      };
      axios
        .post("/Communication/getcommunicationStatus", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.comm_read_ststus = res.data.read_list;
            this.status_dialog = true;
            this.total_receipients = res.data.total_receipients;
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.status_dialog = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        });
    },
    editDialog(item) {
      this.awspath = localStorage.getItem("awspath");
      this.editedItem = item;
      this.edit_dialog = true;
      this.editItemIndex = this.communication_list.indexOf(item);
    },
    save() {
      this.edit_save_attachment_load = true;
      let formData = new FormData();
      for (var i = 0; i < this.edit_attachments.length; i++) {
        let file = this.edit_attachments[i];
        formData.append("files", file);
      }
      formData.append("title", this.editedItem.title);
      formData.append("description", this.editedItem.description);
      formData.append("link", this.editedItem.url);
      formData.append("comm_id", this.editedItem.id);
      axios
        .post("/communicationType/saveEditCommunication", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            this.showSnackbar("#4caf50", "Album Updated Successfully...");
            this.edit_dialog = false;
            this.get_ay_std();
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.edit_save_attachment_load = false;
          this.edit_attachments = [];
          this.edit_dialog = false;
        });
    },
    // Consolidated method for handling cumulative actions (fetch or save)
    handleCumulativeAction(key, action) {
      if (action === 'edit') {
        // Fetch data for editing
        const formData = {
          key: key
        };
        axios
          .post("/Communication/getdataeditAlbumCumulative", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.editedItem_for_cumulative_edit = {
                title: res.data.communication_list[0].title,
                url: res.data.communication_list[0].url,
                from: res.data.communication_list[0].from,
                to: res.data.communication_list[0].to,
                description: res.data.communication_list[0].description,
                attachment_list: res.data.communication_list[0].attachment_list,
                date: res.data.communication_list[0].date,
                key: res.data.communication_list[0].key
              };
              this.edit_cumulative_dialog = true;
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.init_loader = false;
          });
      } else if (action === 'save') {
        // Save edited data
        if (!confirm("Are You Sure You Want To Edit This Album?")) return;
        this.edit_cumulative_loader = true;
        let formData = new FormData();
        for (var i = 0; i < this.edit_attachments.length; i++) {
          let file = this.edit_attachments[i];
          formData.append("files", file);
        }
        formData.append("title", this.editedItem_for_cumulative_edit.title);
        formData.append("link", this.editedItem_for_cumulative_edit.url);
        formData.append("description", this.editedItem_for_cumulative_edit.description);
        formData.append("key", this.editedItem_for_cumulative_edit.key);
        axios
          .post("/Communication/getdataeditAlbumCumulative", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Album Updated Successfully...");
              this.edit_cumulative_dialog = false;
              this.fetchNotices();
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.edit_cumulative_loader = false;
            this.edit_cumulative_dialog = false;
            this.edit_attachments = [];
            this.fetchNotices();
          });
      }
    },
    get_divisions_stream(stream, type) {
      if (type == "stream") {
        const formData = {
          ay: this.academicyear.id,
          stream: stream.id,
        };
        this.division = [];
        this.selected_all_division = false;
        axios
          .post("/Communication/get_stream_divisions", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.division_list = res.data.division_list;
              this.division_list = res.data.division_list.filter(
                item => item.divname !== "ALL"
              );
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            window.console.log(error);
          })
          .finally(() => {
            this.standard = [];
          });
      }
      if (type == "standard") {
        const formData = {
          ay: this.academicyear.id,
          standard: stream,
        };
        this.division = [];
        axios
          .post("/Communication/get_standard_divisions", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.division_list = res.data.division_list;
              this.division_list = res.data.division_list.filter(
                item => item.divname !== "ALL"
              );
            } else {
              this.showSnackbar("#b71c1c", res.data.snackbar);
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            this.stream = "";
          });
      }
    },
    hasWhiteSpace(s) {
      var reWhiteSpace = new RegExp(/^\s+$/);
      if (reWhiteSpace.test(s)) {
        return true;
      }
      return false;
    },
    async putCalendar() {
      if (this.hasWhiteSpace(this.title) || this.title == null) {
        this.showSnackbar("#b71c1c", "Please Enter Title");
        return;
      }

      this.send_btn_load = true;

      const batchSize = 10;
      const totalFiles = this.attachments.length;
      const totalBatches = Math.ceil(totalFiles / batchSize);

      this.totalUploadFiles = totalFiles;
      this.uploadedFilesCount = 0;
      this.uploadProgress = 0;
      this.uploadProgressDialog = true;

      this.communicationMap = null;

      console.log("====================================");
      console.log("TOTAL FILES SELECTED:", totalFiles);
      console.log("BATCH SIZE:", batchSize);
      console.log("TOTAL BATCHES:", totalBatches);
      console.log("====================================");

      try {

        for (let start = 0; start < totalFiles; start += batchSize) {
          const batchNumber = Math.floor(start / batchSize) + 1;
          const batch = this.attachments.slice(start, start + batchSize);

          console.log("------------------------------------");
          console.log("STARTING BATCH:", batchNumber, "OF", totalBatches);
          console.log("BATCH FILE COUNT:", batch.length);
          console.log("BATCH FILES:", batch.map(file => file.name));
          console.log("------------------------------------");

          let formData = new FormData();

          // Add files of current batch
          batch.forEach(file => { formData.append("files", file); });
          formData.append("div", JSON.stringify(this.division));
          formData.append("standard", JSON.stringify(this.standard));
          formData.append("ay", this.academicyear.id );
          formData.append("stream", this.stream ? this.stream.id : null );
          formData.append("title",this.title);
          formData.append("description",this.description);
          formData.append("link",this.link);
          formData.append("type","Album");

          // if (this.communicationId) {
          //   formData.append("communication_id",this.communicationId);
          //   console.log("EXISTING COMMUNICATION ID SENT:",this.communicationId);
          // } else {
          //   console.log("NO COMMUNICATION ID SENT.");
          //   console.log("BACKEND WILL CREATE NEW COMMUNICATION.");
          // }

          if (this.communicationMap) {
            formData.append("communication_map", JSON.stringify(this.communicationMap));
          }

          console.log("API CALL STARTED FOR BATCH:",batchNumber);

          const res = await axios.post("/Communication/putNoticeHWAlbum", formData);

          console.log( "API RESPONSE FOR BATCH:",batchNumber,res.data);

          if (res.data.msg === "200" &&  res.data.status === "SUCCESS") {
            console.log("BATCH", batchNumber, "UPLOADED SUCCESSFULLY");

            // if (!this.communicationId && res.data.communication_id) {
            //   this.communicationId = res.data.communication_id;
            //   console.log("NEW COMMUNICATION ID STORED:",this.communicationId);
            // }
            if (!this.communicationMap && res.data.communication_map) {
              this.communicationMap = res.data.communication_map;
              console.log("NEW COMMUNICATION MAP STORED:", Object.values(this.communicationMap));
            }

            this.uploadedFilesCount = Math.min(
              this.uploadedFilesCount + batch.length,
              totalFiles
            );

            this.uploadProgress = Math.round(
              (this.uploadedFilesCount / totalFiles) * 100
            );

            // Check whether all files are uploaded
            if (this.uploadedFilesCount >= totalFiles) {
              this.uploadCompleted = true;
            }

            this.showSnackbar(
              "#4caf50",
              this.uploadedFilesCount +
              " of " +
              totalFiles +
              " files uploaded successfully"
            );
          } else {
            console.error("BATCH",batchNumber,"FAILED:",res.data.status_reason);
            this.showSnackbar("#b71c1c","Upload failed at Batch " + batchNumber + ": " + res.data.status_reason);

            // Stop remaining uploads
            break;
          }
        }

        console.log("====================================");
        console.log("ALL BATCHES PROCESSED");
        console.log("COMMUNICATION ID:",Object.values(this.communicationMap));
        console.log("====================================");

      } catch (error) {
        console.error("ERROR WHILE UPLOADING FILES:",error);

        this.showSnackbar("#b71c1c","Something went wrong while uploading files");

      } finally {
        this.send_btn_load = false;
        this.uploadProgressDialog = false;
      }
    },
    get_ay_std() {
      const formData = {
        comm_type: "Album",
        for: "all",
      };
      axios
        .post("/Communication/gerInitialData", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;
            this.academicyear = res.data.current_ay;
            this.stream_list = res.data.stream_list_all;
            this.standard_list_all = res.data.standard_list_all;
            this.standard_list_all = res.data.standard_list_all.filter(
              item => item.standard !== "All"
            );
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.first_load = true;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    deleteCalendarEvent(item) {
      this.delete_attach_load = true;
      if (!confirm("Are you sure you want to delete this calendar event?"))
        return;
      const formData = {
        comm_id: item.id,
      };
      axios
        .post("/communicationType/deleteCommunication", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar("#4caf50", res.data.status_reason);
            this.get_ay_std();
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.delete_attach_load = false;
          this.fetchNotices();
          this.get_ay_std();
        });
    },
  },
  mounted() {
    this.get_ay_std();
    this.basepath = localStorage.getItem("awspath");
    this.view = "Single";
  },
};
</script>

<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}

.allot-btn:hover .allot-icon {
  color: white;
}

.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}

.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}

@media print {
  body {
    height: 100%;
    width: 100%;
  }

  .no-display {
    display: none !important;
  }

  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }

  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}

.sp1 {
  font-size: 13px;
}
</style>